export const handleOnPlusClick = ({
  setShow = () => {},
  setFieldToFocus = () => {},
  setVital = () => {}
}) => {
  setShow(true);
  setFieldToFocus('');
  setVital({});
};
